/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Raffle_No_DrawsInputs */



/**
* | output |
* | --- |
* | "No raffle draws to undo" |
*
* @param {Err_Tournament_Raffle_No_DrawsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_raffle_no_draws = /** @type {((inputs?: Err_Tournament_Raffle_No_DrawsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Raffle_No_DrawsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun tirage au sort à annuler")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay sorteos que deshacer")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum sorteio para desfazer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna estrazione da annullare")
	return /** @type {LocalizedString} */ ("No raffle draws to undo")
});